<script>
import axios from 'axios'

  export default {
    name: "ToggleDiv",
    
    

    props: {
      msg: String,
    },

    data() {
    return {
      isShow1: true,
      isShow2: true,
      isShow3: true,
      isShow4: true,
      isShow5: true,
      isShow6: true,
      isShow7: true,
      isShow8: true,
      isShow9: true,
      isShow10: true,
      isShow11: true,
      isShow12: true,
      isShow13: true,
      isShow14: true,
      isShow15: true,
      filesrcs: [
        {
          title: 'fourierCode.jpg',
          src: require('@/assets/fouriercode.jpg'),
        },
      ],
    }
  },
  methods: {
    forceFileDownload(response, title) {
      console.log(title)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    downloadWithAxios(url, title) {
      axios({
        method: 'get',
        url,
        responseType: 'arraybuffer',
      })
        .then((response) => {
          this.forceFileDownload(response, title)
        })
        .catch(() => console.log('error occured'))
    },
  }
  };
</script>




<template>

    <h1>Signale</h1>
     <div align="center" id="cardsWrapper"> 

      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="true">
        <h5 class="card-title">Was ist ein Signal?</h5>
        <div class="card-body" align="left">
          Im Allgemeinen ist ein Signal eine Darstellung von Informationen. Es beschreibt den Verlauf einer physikalischen Größe über der Zeit/Raum.
          <br>
          <br>
          Als Beispiel zählt Herr Prof. Müller in seiner Vorlesung den Verlauf der Amplitude der Ausgangsspannung eines Mikrofons über der Zeit auf.
          <br>
          <br>
          Da es viele Signale gibt, sind für dieses Modul insbesondere die Audiosignale interessant. Diese entstehen durch Änderungen des Luftdrucks. Die Druckschwankungen der Luft, die der Mensch im Ohr wahrnimmt, werden auch als Schallwellen bezeichnet. Eine Darstellung eine Audiosignals erfolgt auch als eine Funktion über der Zeit.
          <br>
          <br>
          Mehr dazu findet ihr im nächsten Feld.
        </div>
        
        <button class="btn btn-secondary"  @click="isShow1 = !isShow1" v-if="isShow1">Weiter</button>
      </div>

      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="!isShow1">
        <h5 class="card-title">Analoge vs. Digitale Signale</h5>
        <div class="card-body" align="left">
            Weitere unterscheiden wir bei Signalen, ob sie analog oder digital sind.
            <br>
            <br>
            
            Analoge Signale sind physikalische Größen, die sowohl im Zeit- und Wertebereich kontinuierliche Werte annehmen. Dies bedeutet, dass zu jedem Zeitpunkt beliebig verschiedene Werte angenommen werden können. Die Grundform für solch ein Signal ist die Sinusform, also ein zeitlicher Verlauf. Obwohl nicht alle einen sinusförmigen Verlauf annehmen, bilden die Sinusfunktion auch für nichtsinusförmige Signale die Grundform. Durch Überlagerungen mehrerer Sinusfunktionen können Nichtsinusförmige so aufgeteilt werden. Beispielhaft gehören die bereits erwähnten Audiosignal zu den analogen Signalen.
            <br>
            <br>
            Solche Signale eignen sich jedoch nicht für die Verarbeitung, Bearbeitung und Speicherung. Da beispielsweise das Speichern von analogen Signalen, aufgrund seiner theoretisch unendlich vielen Informationen, einen unendlichen Speicherbedarf benötigen würde. Zudem sind sie gegen Störungen viel anfälliger, sodass Informationsverluste entstehen können (Einmal hinzugefügte Störungen in einem Analogsignal können nicht mehr rückgängig gemacht werden.)
            <br>
            <br>

 
            <div class="card shadow-sm p-3 mb-5 bg-white rounded" align="center"> 
              <h5>Digitale Signale</h5>
              <div class="card-body" align="left">
                Um dies zu vermeiden, erweisen sich digitale Signale als vorteilhaft. Im Gegensatz zu den analogen Signalen, ist ein digitales eine physikalische Größe, die nur bestimmte diskrete, auch genannt als ‚endliche‘, Werte annimmt.
                Ein digitales System wird durch die Abtastung der diskreten Werten im Zeitbereich und der Quantisierung der Werten im Wertebereich dargestellt.
              </div>
            </div>
          </div>
        <button class="btn btn-secondary"  @click="isShow2 = !isShow2" v-if="isShow2">Weiter</button>
      </div>      

  



      
      
      
      
      <div v-if="!isShow2" class="card shadow-sm p-3 mb-5 bg-white rounded" style="width:60%">
          <h5>Digitalisierung</h5>
          <div class="card-body">
            <div class="card shadow-sm p-3 mb-5 bg-white rounded">
              <h5>Abtastung (Zeitbereichsdiskretisierung)</h5>
              <div class="card-body" align="left">
                In der Signalverarbeitung wird bei der Abtastung ein zeitkontinuierliches Signal zu einem zeitdiskreten Signal reduziert. 
                Dafür wird zunächst eine Samplingfrequenz f gewählt, welche die Abstände festlegt, in denen die Werte des Signals abgetastet werden. 
                Dieser Abstand beträgt dabei immer eine Periodendauer mit T = 1/f.
                <br>
                <br>
                Bei einer Abtastfrequenz von 1 Hz ergäbe sich dann ein Intervall von 1s. Ein Abgetastetes Signal resultiert daher dann in einer 'Reihe' an Werten.

                <div align="center">
                  <img src="@/assets/Abtast_1.jpg" alt="Quantisierung Beispiel" width="1000">
                </div> 

                <br>
                Um bei der Abtastung einen Erhalt der gesamten Information garantieren zu können, muss das Abtasttheorem nach <b>Nyquist</b> und<b> Shannon</b>  beachtet werden.
                 <br>
                 <br>
              <button style="width:100%" class="btn btn-secondary"  @click="isShow3 = !isShow3" v-if="isShow3">Weiter</button>
              <div v-if="!isShow3" class="card shadow-sm p-3 m-3 mb-5 bg-white rounded">
                <h5>Abtasttheorem nach Nyquist u. Shannon & Aliasing</h5>
                <div class="card-body" align="left">
                  Das Nyquist-Shannon Theorem besagt, dass die Abtastfrequenz für ein gegebenes Signal, mit einer maximalen Frequenz von f, immer mindestens doppelt so 
                  groß sein muss wie f, um eine verlustfreie Abtastung zu ermöglichen. Das bedeutet, das für den menschlichen Hörbereich (20 Hz - 20 kHz) 
                  immer eine Abtastfrequenz von mindestens 40 kHz gegeben sein muss, um Verzerrungen vorzubeugen.

                  <br>
                  <br>
                  Diese Verzerrungen werden <b>Aliasing</b> genannt. Sie können als Spiegelungen an der maximal ermöglichten Frequenz (auch Nyquistfrequenz genannt) bezeichnet werden.
                  Dies führt zu unerwünschten Artefakten, welche generell als unschön empfunden werden.



                </div>
                <button style="width:100%" class="btn btn-secondary"  @click="isShow4 = !isShow4" v-if="isShow4">Weiter</button>
              </div>

              </div>
            </div>



            <div v-if="!isShow4" class="card shadow-sm p-3 mb-5 bg-white rounded">
              <h5>Quantisierung</h5>
              <div class="card-body" align="left">
                Durch die Abtastung entstehen zwar zeitlich diskrete Werte, allerdings sind diese weiterhin wertkontinuierlich.
                Ein abgetatsteter Wert könnte bspw. 1,5 V betragen. Bei der Quantisierung werden diese Werte nun zu digital darstellbaren Werten umgeformt. Die Auflösung dessen legt die <b>Bittiefe</b> fest.
                <br>
                <br>
                Ein typisches Audiosignal wird oft mit 16 bit kodiert. Jedem abgetasteten Wert 2^16 stehen somit verschiedene mögliche Werte zur Verfügung .
                Für 16 bit Audiosignale gäbe es zwischen 1 und -1 2^16 verschiedene Werte mit denen die Spannung dargestellt werden kann.
                <br>
                Ein abgetasteter Wert kann vor der Wertbereichsdiskretisierung zwischen dem <b>Quantisierungsraster</b> liegen. 
                Bei der Quantisierung selbst wird dieser Wert auf den nächstgelegenen digital darstellbaren Wert gerundet.
                <br>
                <br>
                Hier wird also beispielsweise der Wert 1,5 auf 2 gerundet.

                <div align="center">
                  <img src="@/assets/Quant_1.jpg" alt="Quantisierung Beispiel" width="100%">
                </div>

                <br>
                <br>
                Wird ein Signal mit einer zu geringen Bittiefe abgetastet, entstehen Audiofragmente, welche auch als Quantization-Noise bezeichnet werden. Hierbei handelt es sich um diw Abweichung des quantisierten Signals vom Ursprungssignal. <br> 
                Dieser werden in der Regel als störend empfunden, weshalb die Bittiefe, gerade für die Audioproduktion, entsprechend hoch gewählt werden muss. <br>
                <br>

                <div align="center">
                  <img src="@/assets/quantizationnoise.jpg" alt="Quantization Noise JPEG https://www.google.com/url?sa=i&url=https%3A%2F%2Fe2e.ti.com%2Fblogs_%2Farchives%2Fb%2Fprecisionhub%2Fposts%2Fhow-to-use-thermal-noise-to-your-advantage&psig=AOvVaw0P4r3MsMOWkofaTLNBkkeb&ust=1645178172981000&source=images&cd=vfe&ved=0CAsQjRxqFwoTCOjYr7y8hvYCFQAAAAAdAAAAABAD" width="50%">
                </div>

                <br>

                <ul class="nav nav-pills justify-content-center">
                  <li class="active"><a data-toggle="pill" href="#achtbit"><button class="btn btn-secondary m-3" style="width:100px">8 bit</button></a></li>
                  <li><a data-toggle="pill" href="#bit"><button class="btn btn-secondary m-3"  style="width:100px">16 bit</button></a></li>
                </ul>


                <div class="tab-content m-3" align="center">
                    
                    <div id="achtbit" class="tab-pane fade">
                      <h3>8 bit</h3>
                      <audio controls="true">
                      <source src="@/assets/Audio/8bit.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>
                    </div>

                    <div id="bit" class="tab-pane fade in active">
                      <h3>16 bit</h3>
                      <audio controls="true">
                      <source src="@/assets/Audio/16bit.wav" type="audio/wav">
                      Your browser does not support the
                      <code>audio</code> element
                      </audio>
                    </div>

                  </div>




              </div>
              <button style="width:100%" class="btn btn-secondary"  @click="isShow5 = !isShow5" v-if="isShow5">Weiter</button>

            </div>
            <div align="center" class="card shadow-sm p-3 mb-5 bg-white rounded" v-if="!isShow5">
              <div class="card-body" align="left">
                Nach Durchführung beider Schritte, ist das Signal vollständig diskretisiert und damit ein digitales Signal.
                Dieses Signal ist nun <b>Werte- und Zeitdiskret</b> und kann daher digital weiterverarbeitet werden.

                <div align ="center">
                  <img src="@/assets/PCM_Ergebnis.jpg" alt="Digitalisiertes Signal" width="1000">
                </div>
              </div>
              <button style="width:100%" class="btn btn-secondary"  @click="isShow6 = !isShow6" v-if="isShow6">Weiter</button>

            </div>

            



            <div class="card shadow-sm p-3 mb-5 bg-white rounded" v-if="!isShow6">
              <h5>Vor- und Nachteile Digitaler Signale</h5>
              <div class="card-body" align="left">
                Die digitalen Signale bieten im Gegensatz zu analogen eine Störsicherheit, da im Prinzip verlustlos übertragen wird. 
                Die Analogen dagegen sind für Störungen viel anfälliger, sodass Informationsverluste entstehen können. Da einmal hinzugefügte Störungen in einem analogen Signal nicht mehr rückgängig gemacht werden können. Ein weiterer Vorteil ist die Universalität: Unterschiedliche Signale werden auf demselben Weg übertragen. Digitalrechner erleichtern zudem die einfache Verarbeitung.
                Ein Problem, welches auftreten kann, ist zum einen der Quantisierungsfehler, welcher durch den begrenzten Wertevorrat entstehen kann. Zum Anderen treten bei der Abtastung mögliche Fehler auf. Da wie bereits erwähnt, die analogen Signale mit doppelter Frequenz abgetastet werden müssen, wird eine höhere Bandbreite benötigt.



              </div>
              <button style="width:100%" class="btn btn-secondary"  @click="isShow11 = !isShow11" v-if="isShow11">Weiter</button>

            </div>
          </div>
      </div>
        









         


      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="!isShow11">
        <h5 class="card-title">SNR</h5>
        <div class="card-body" align="left">
          <b>Signal-Rausch-Verhältnis, Störabstand, Signal-to-Noise Ratio</b>
          <br>
          <br>
          Der Störabstand, kurz SNR, ist ein Maß für die technische Qualität eines Nutzsignals, welches von einem Rauschsignal überlagert wird. Um Information sicher aus einem Signal entnehmen zu können, muss sich das Nutzsignal deutlich vom Rauschsignal/Hintergrundrauschen abheben. Der Störabstand muss dementsprechend groß ausfallen. <br>
          Ein solches Rauschen lässt sich in Signalen nicht vermeiden, da es durch beispielsweise dem thermischen Eigenrauschen elektrischer Komponenten oder auch durch ein unvermeidbares Quantisierungsrauschen bei endlicher Bitrate entsteht. Ein qualitativ hochwertiges Signal in dieser Hinsicht besitzt eine hohe SNR, bestenfalls unter dem menschlichen Hörabstand, sodass es nicht vernehmbar ist. <br>
          <br>
          Damit Menschen ein Signal deutlich wahrnehme und vom Rauschen unterscheiden können, ist mindestens ein SNR von ca. 6dB erforderlich.
          <br>
          <br>
          Ein geringer SNR Wert würde wiederum bedeuten, dass das Nutzsignal sich nur wenig vom Rauschsignal unterscheidet.

          <div align="center">
            <img src="@/assets/SNR.png" alt="https://www.google.com/url?sa=i&url=https%3A%2F%2Fdocumentation.meraki.com%2FMR%2FWiFi_Basics_and_Best_Practices%2FSignal-to-Noise_Ratio_(SNR)_and_Wireless_Signal_Strength&psig=AOvVaw3SwGkfOBf9fN3htC1v6ycb&ust=1644599568509000&source=images&cd=vfe&ved=0CAsQjRxqFwoTCLjqlIbR9fUCFQAAAAAdAAAAABAD">
          </div>

          <button style="width:100%" class="btn btn-secondary"  @click="isShow7 = !isShow7" v-if="isShow7">Beispielrechnung anzeigen</button>





          <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 100%;" v-if="!isShow7" align="center">
            <h5 class="card-title">Beispiel</h5>
            <div class="card-body" align="left">
              In einem Raum befindet sich eine Geräuschequelle mit  L1  = 100 dB und eine Signalquelle mit <br>
              L2  = 75 dB. Wie hoch ist das Signal-Rausch-Verhältnis in Dezibel? <br>
              <br>
              Formel:   SNR = 10 * log( Signal/ Noise) = 10 * log(Signal) - 10 * log (Noise) <br>
              <br>
              Geg:  Signalquelle = 75dB   <br>  
              Geräuschequelle = 100dB <br>
              <br>
              SNR = 10 * log(Signal) - 10 * log (Noise) <br>  
              <br>
              SNR = 75dB - 100dB <br>
                  = -25dB



              
            </div>
            <button style="width:100%" class="btn btn-secondary"  @click="isShow8 = !isShow8" v-if="isShow8">Weiter</button>

          </div>





        </div>
      </div>  


      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="!isShow8">
        <h5 class="card-title">Datenrate</h5>
        <div class="card-body" align="left">
          Die Datenrate eines Signals gibt an, wie Daten oder Informationen in einer bestimmten Zeit übertragen werden können. Bei diesen Informationseinheiten kann es sich um Bits oder Bytes, um Zeichen, Frames oder Datenblöcke handeln, welche in einem bestimmten Zeitintervall übertragen werden. 
          Datenraten werden in Bit pro Sekunde (bit/s) angegeben. Genauso sind auch in Kilobit pro Sekunde (kbit/s), Megabit pro Sekunde(Mbit/s) und Gigabit pro Sekunde (Gbit/s) möglich.
          <br>
          <br>
          Für dieses Modul die Berechnung einer Audio Datenrate interessant:
          <br>



          <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-3" style="width: 100%;" v-if="!isShow2">
            <h5 class="card-title">Datenrate eines Audiosignals berechnen</h5>
            <div class="card-body" align="left" style="width:100%">
              Datenrate = Abtastfrequenz * Bits für quantisierten Wert * Anzahl der Kanäle
              <br>
              <br>
              In folgendem Beispiel wird die Datenrate für ein unkomprimiertes (stereo-) Audiosignal auf einer Audio-CD in üblicher Qualität berechnet:
              <br>
              <br>
              Audio-CD Quantisierung =  16bit (Bitrate) <br>
              Stereo => 2 Kanäle <br>
              Abtastfrequenz = 44100 Hz <br>
              <br>
              Datenrate = 44100 * 16 Bit * 2 <br>
              Datenrate = 1411 kb/s

            </div>
            
          </div>
          <button class="btn btn-secondary"  @click="isShow9 = !isShow9" v-if="isShow9" style="width: 100%">Weiter</button>


        </div>
      </div>









      <div align="center" v-if="!isShow9">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;">
          <h5 class="card-title">Fouriertransformation</h5>
          <div class="card-body" align="left">
            Bei der Fourieranalyse wird ein gegebenes Signal (z.B. ein Klang) in seine Grundlegenden Komponenten (z.B. Sinustöne) zerlegt und diese können anschaulich dargestellt werden werden.
            <div align="center">
              <img src="@/assets/Fourier.jpg" alt="Fourierrechnung" width="60%">
            </div>
            
            <br>
            <br>
            Dadurch kann jedes (periodische) Signal mithilfe dieser Transforamtion in seine Grundkomponenten zerlegt und dann angezeigt werden.
            Gleichzeitig erhält man nicht nur Informationen über die Frequenz der Grundlegenden Signale, sondern auch über die Phase. In vielen Musikalischen Anwendungsgebieten
            wird die Phase vernachlässigt und nur die Frequenzen grundlegend dargestellt. So ein Plot wird dann Betragsspektrum genannt.
          
            <br>
            <br>
            <div align="center">
              <img src="@/assets/Audio/FourierSquare.gif" alt="Fourier Square Animation" class="m-3">
              <img src="@/assets/Audio/Fourier2.gif" alt="Fourier Square Animation" class="m-3">
            </div>
            Wenn die Frequenzachse dabei mit einer linearen Skalierung gewählt wird, lassen sich die Relationen der Obertöne zueinander gut erkennen. Dabei sind die ganzen vielfachen des Grundtons immer die 'harmonischen Obertöne'.
            Beispielhaft bei der Squarewave (oder auch Rechteckfunktion) wird die Frequenz von 440Hz angezeigt.
            <br>
            Hier wurde aus der Animation ein Signal, bestehend aus vier Sinus-Signalen, zum Grundton und den ersten drei Obertönen einer Rechteckschwingung bei 440Hz zusammengesetzt. <br>
            Wenn dieses Signal wieder durch die Fouriertransformation in seine Grundlegenden Komponenten zerlegt wird, lassen sich wie erwartet, die vier Sinusschwingungen erkennen.
            In dieser Betrachtung wird auf die Phase verzichtet und nur das <b>Betragsspektrum</b> aus dem Ergebnis der Fouriertransformation herausgerechnet.
            <br>
            <br>
            Bei der Durchführung einer Fouriertransformation werden auch im komplexen Ergebnis immer die Phaseninformation der Signale mitgegeben.
            <br>
            <br>
            <div align="center" class="p-3">
              <img src="@/assets/fourierSquarePlot.png" alt="Fourier Square plot" class="m-3" width="1000">
            </div>



            <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 100%;">
            <div class="m-3">
              <div align="center">
                  <button  type="button" class="btn btn-info btn-sm" data-toggle="modal" data-target="#ModalFourier" style="width:30%">
                    Python Code anzeigen
                  </button>

              </div>
                

                <!-- Modal -->
                <div class="modal fade" id="ModalFourier" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Rechtecksignal aus Sinus-Signalen - analysiert</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <img src="@/assets/fouriercode.jpg" alt="Python Code Fourier">
                      </div>
                      <div class="modal-footer">
                        <v-flex v-for="(filesrc, index) in filesrcs" :key="index" xs12 md4>
                          <v-card @click="downloadWithAxios(filesrc.src, filesrc.title)" class="btn btn-secondary m-3" style="width:100%">
                            <v-list>
                              <v-list-item>
                                
                                <v-list-item-icon>
                                  <v-icon class="primary--text"> Download</v-icon>
                                </v-list-item-icon>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-flex>
                        <button type="button" class="btn btn-secondary m-3" data-dismiss="modal">Close</button>

                        
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            </div>

            

            <b>Das ganz hört sich dann folgendermaßen an:</b> <br> <br>
            <div align="center">
              <audio controls="true" >
                <source src="@/assets/Audio/Rectangle_combined.wav" type="audio/wav">
                Your browser does not support the
                <code>audio</code> element
              </audio>
            </div>
            <br>
            <br>
            Wenn man nun dieses Schema unenedlich fortführt, bekommt man eine ideale Rechteckwelle. 
            <br>
            <br>


            <div align="left" style="m-3">
              <img src="@/assets/Fourier2.jpg" alt="Fourier Rechteck unendlich">
            </div>


            <button class="btn btn-secondary"  @click="isShow13 = !isShow13" v-if="isShow13" style="width: 100%">Weiter</button>



            <div class="card m-3 mt-5" v-if="!isShow13">
              <h5 align="center" class="m-3 ">(Quasi-)Fouriertransformation im Ohr</h5>
              <div class="card-body" align="left">
                Der Umwandlungsprozess in unserem Innenohr von einem physischen Signal in ein Elektrochemisches funnktioniert nach einem ähnlichen Schema. Dabei wird eine Frequenz-Ort-Analyse durchgeführt.
                In der Cochlea teilt sich das Signal nach der Frequenz über den Ort auf, wobei dann hohe Töne am Anfang - und tiefe Töne am Ende der Cochlea ihr energetisches Maximum haben. 
                <br>
                Anschaulich lässt sich das mit einem Betragsspektrum vergleichen. Auch hier entspricht die Auflösung eher einer logartihmischen Verteilung und es stellt sich dementsprechend auch hier eine geringere Auflösung zu hohen Frequenzen ein.
              </div>
              <button style="width:100%" class="btn btn-secondary"  @click="isShow10 = !isShow10" v-if="isShow10">Weiter</button>

            </div>
          </div>

        </div>
      </div>  





      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="!isShow10">
        <h5 class="card-title">Logartihmische Darstellung</h5>
        <div class="card-body" align="left">
        Für die Darstellung von Audiosignalen ist es üblich, eine logarithmische Skalierung sowohl für die Frequenz, als auch für die Amplitude (Pegel) zu wählen. Dahingehend enspricht unser Gehör in beiden Aspekten eher dem einer logarithmischen Wahrnehmung.
        <br><br>
        Dazu eine kleine Wiederholung zur Pegelrechnung:

          <div class="card shadow-sm p-3 mb-5 bg-white rounded">
            <h5 align="center">Pegelrechnung</h5>
            <div class="card-body">
              Physikalische Größen wie beispielsweise akustische Größen können über einen sehr großen Wertebereich verfügen. Um diese besser darstellen zu können, gibt es den Pegel.
              Der Pegel ist ein logarithmisches Verhältnis zwischen zwei Größen. 
              Dieser wird zur Bestimmung der Spannung, Ströme oder Leistungen verwendet.
              Das Formelzeichen hierfür ist <b>L</b>.

              <div align="center" class="p-3">
                <img src="@/assets/Pegelrechnung1.jpg" alt="Pegelrechung allgemein">
              </div>

              <h4>Pegel: Leistungs und Leisungswurzelgrößen</h4>
              Für die Pegelrechnung ist das Verständnis zwischen Leistungsgrößen (Energiegrößen) und Leistungswurzelgrößen (Feldgröße) relevant.
              Eine Leistungsgröße ist proportional zu ihrer Energie. Bei den Leistungswurzelgrößen wiederum sind deren Quadrat proportional zur Energie.
              Beim Pegel wird nur mit Leistungsgrößen gerechnet. Demzufolge müssen die Feldgrößen in Energiegrößen umgewandelt werden.
              Dies bedeutet, dass bei der Pegelrechnung mit Leistungswurzelgrößen die Größe und der Bezugswert quadriert (i.d.R wird mit dem Faktor 2 multipliziert) werden müssen. Anschließend wird das Verhältnis logarithmiert.

              <div align="center" class="m-3">
                <img src="@/assets/Pegelrechnung2.jpg" alt="Pegelrechung Energie">
              </div>

              <h5>Schalldruckpegel (Leistungswurzelgröße)</h5>
              Der Schalldruckpegel (<b>Lp</b>) ist eine technische Größe und wird in der Messtechnik als die Maßeinheit des Schalls bezeichnet. Er steht im Zusammenhang mit dem physikalischen Schalldruck (<b>p</b>), welcher in der Einheit <b>Pa</b> (Pascal) angegeben wird. Der Schalldruck ist die Änderung des Drucks in dem Medium, in welchem sich der Schall ausbreitet.
              Da der Schalldruck eine schwingende Größe ist, wird der quadratische Mittelwert ( <b>Root mean square</b>) berechnet.
              <br>
              <br>
              Demnach ist der Schalldruckpegel, der Schalldruck logarithmiert mit einem Referenzwert. 
              <br>
              <br>

              <h5>Schallleistungspegel (Leistungsgröße)</h5>
              Die Schallleistung gibt die Energie pro Zeit, die eine Schallquelle abgibt. Dabei ist der Schallleistungspegel ortsunabhängig.
              <br>
              <br>


              <h5>Schallintensitätspegel (Leistungsgröße) </h5>
              Die Schallintensität ist die Leistung die je Flächeninhalt durch eine durchschallte Fläche trifft.
              Im Prinzip  ist der Schallintensitätspegel die Schallleistung pro Fläche.


              <div align="center" class="p-3">
                <img src="@/assets/pegelgrößen.jpg" alt="PegelGrößen">
              </div>


            <div class="card m-3">
              <h5 align="center" class="m-3">Faustregeln</h5>
              <div class="card-body" align="left">
                <ol>
                  <li>2 gleich laute Schallquellen bewirken einen um etwa 3dB höheren Gesamtpegel.</li>
                  <li>2 sich um 10 dB unterscheidende Pegel sind zusammen so laut wie die lautere Quelle.</li>
                  <li>Pegel können nicht einfach addiert oder subtrahiert werden! Wir müssen (i.d.R) zuerst auf ihre Ausgangsgröße zurückrechnen, dann addieren und danach wieder logarithmieren. </li>
                </ol>

              </div>
            </div>

            <div class="card m-3">
              <h5 align="center" class="m-3">Rechenbeispiele</h5>
              <div class="card-body" align="left">
                <b>1)</b> <br>
                <b>Gegeben:</b> Eine <b>Schallleistung P = 5mW</b> <br>
                <b>Gesucht:</b> Der <b>Schallleistungspegel Lw</b> <br>
                
                <br>
                Lw = 10 * log10(P/P0)) dB <br>
                <br>
                Lw = 10 * log10(5*10−3 W / 1*10−12 W) dB <br>
                <br>
                Lw = 10 * log10(5* 107) dB <br>
                <br>
                = 76,98 dB <br>
                <br>
                <br>
                <b>2)</b> <br>
                In einem Raum befinden sich <b>zwei Schallquellen</b>. In einem Punkt erreichen die Schallquellen folgenden Schalldruck mit <b>Lp1 = 0,2</b> Pa und <b>Lp2 = 0,5 Pa</b>. Wie hoch ist der daraus resultierende Schalldruckpegel an dieser Stelle in Dezibel? <br> 
                
                <br>
                <b>Formel:</b> Lp = 20 * log10(p/p0) dB, Referenzwert  p0  = 2 * 10−5 Pa <br>
                <br>
                LpGes  =  20 * log10(p1 + p2 / p0) dB <br>
                <br>
                =  20 * log10(0,2 + 0,5 / 2 * 10−5 Pa) dB <br>
                <br>
                = 90,88 dB
                <br>



              </div>
            </div>

              

            </div>
            <button class="btn btn-primary"  @click="isShow12 = !isShow12" v-if="isShow12">Modul abschließen</button>

            
          </div>
        </div>
      </div> 



    
    </div>



    


</template>
